import Vue from 'vue'
import ClickOutside from 'vue-click-outside'

/* eslint-disable */
Vue.directive('click-outside', ClickOutside)
